import React, {useState, useEffect} from 'react';
import { useDeviceLayout } from "./DeviceLayoutProvider";

const Button = ({ children, type = "full", onClick = () => {}, disabled = false, classes = "", color="blue" }) => {
    const { isLittle } = useDeviceLayout();
    const colors = {
        blue: {
            full: "bg-blue-600 hover:bg-blue-700 text-white",
            hollow: "border-blue-600 text-blue-600 hover:bg-gray-200 hover:dark:bg-neutral-800",
            icon: "text-blue-600"
        },
        yellow: {
            full: "bg-yellow-500 hover:bg-yellow-600 text-white",
            hollow: "border-yellow-500 text-yellow-500 hover:bg-gray-200 hover:dark:bg-neutral-800",
            icon: "text-yellow-500"
        },
        green: {
            full: "bg-green-600 hover:bg-green-700 text-white",
            hollow: "border-green-600 text-green-600 hover:bg-gray-200 hover:dark:bg-neutral-800",
            icon: "text-green-600"
        }
    };
    const types = {
        full: `flex justify-center items-center font-medium py-2 ${isLittle ? 'px-2' : 'px-4'} rounded-lg hover:cursor-pointer active:scale-95 transition-all ${colors[color].full}`,
        hollow: `flex justify-center items-center border-2 font-medium py-2 ${isLittle ? 'px-2' : 'px-4'} rounded-lg hover:cursor-pointer active:scale-95 transition-all ${colors[color].hollow}`,
        icon: `hover:cursor-pointer active:scale-95 transition-all ${colors[color].icon}`
    };

    const [buttonClasses, setButtonClasses] = useState(types[type]);

    useEffect(() => {
        setButtonClasses(types[type]);
    }, [type]);

    return (
        <button className={`text-xs md:text-base ${buttonClasses} ${classes} ${disabled && 'opacity-50 cursor-not-allowed'}`} onClick={onClick} disabled={disabled}>
            {children}
        </button>
    );
};

export default Button;